/**
 * @module Services/Bff/Presenters/PaymentMethods
 * @desc PaymentMethods Presenter
 *
 */

import { paymentFormatPresenter } from './helpers';

import type { PaymentPlansNewPresenterResponse } from '../../@types';
import type { Checkout } from 'core/domains';

/**
 * Returns the formatted payment information from BFF to the store
 *
 */
export function paymentMethodsPresenter({
  data,
}: PaymentPlansNewPresenterResponse): Checkout['paymentMethods']['data'] {
  const bankSlip = data?.payments?.filter(
    (payment) => payment.paymentPlanType === 'bankBilling',
  )[0];
  const creditCard = data?.payments?.filter(
    (payment) => payment.paymentPlanType === 'creditCard',
  )[0];
  const pixPayment = data?.payments?.filter((payment) => payment.paymentPlanType === 'pix')[0];
  const other = data?.payments?.filter((payment) => payment.paymentPlanType === 'other')[0];
  const dataCreditCard = paymentFormatPresenter(creditCard);
  const hasPaymentInfo = !!Object.keys(dataCreditCard?.paymentInfo ?? {}).length;

  const response = {
    bankSlip: paymentFormatPresenter(
      bankSlip,
    ) as unknown as Checkout['paymentMethods']['data']['bankSlip'],
    creditCard: dataCreditCard?.paymentInfo
      ? ({
          ...dataCreditCard,
          hasPaymentInfo,
        } as unknown as Checkout['paymentMethods']['data']['creditCard'])
      : ({} as unknown as Checkout['paymentMethods']['data']['creditCard']),
    pixPayment: paymentFormatPresenter(
      pixPayment,
    ) as unknown as Checkout['paymentMethods']['data']['pixPayment'],
    centralPayment: paymentFormatPresenter(
      other,
    ) as unknown as Checkout['paymentMethods']['data']['centralPayment'],
  };

  return response;
}
